import classnames from 'classnames'
import React from 'react'

// Utils

import { Image as ImageC } from '@src/quince-components/src'
import Image from '@src/quince-site-common/src/domains/Image'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

// Styles
import * as dsStyles from './product-details-icon-ds.styles'
import stylesV2 from './product-details-icon-v2.module.scss'
import styles from './product-details-icon.module.scss'
export enum PRODUCT_DETAILS_ICONS {
  MINIMAL_PACKAGING = 'minimalPackaging',
  OEOKO_CERTIFIED_SVG = 'oeokoCertifiedSvg',
  REDUCED_CARBON_FOOTPRINT = 'reducedCarbonFootpring',
}

export interface ProductDetailsIconProps {
  displayTitle: string
  image?: Image
}

const ProductDetailsIcon = ({ displayTitle, image }: ProductDetailsIconProps) => {
  // DS gate on → Panda twins of the V2 chip (legacy rem sizes balloon at the 16px DS root).
  if (shouldUseDesignSystem()) {
    return (
      <div className={dsStyles.chipDsClass}>
        {image && <ImageC {...image} className={dsStyles.iconWrapperDsClass} />}
        <div className={dsStyles.iconTextDsClass}>{displayTitle}</div>
      </div>
    )
  }
  const finalStyles = stylesV2
  const classes = classnames(finalStyles.icons)
  return (
    <div className={classes}>
      {image && <ImageC {...image} className={styles.icons__iconWrapper} />}
      <div className={styles.icons__iconText}>{displayTitle}</div>
    </div>
  )
}

export default ProductDetailsIcon
